<template>
<div>
  <h3
    class="text-center"
  >
    Digest Specifics
  </h3>

  <div class="container pb-3">
    <div class="row">
      <div class="col-4">
        Included Puzzle Types
      </div>
      <div class="col-8">
        <div
          class="list-group"
        >
          <router-link
            :class="$root.listItemClasses"
            :to="{
              name: 'provider',
              params: {
                providerId: provider.id
              }
            }"
            :key="provider.id"
            v-for="provider in providers"
          >
            {{ provider.attributes.title }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Last Sent At
      </div>
      <div class="col-8">
        {{ $root.displayDateTimeFmt(digest_last_sent_at) || 'n/a'}}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Next Digest Starts At
      </div>
      <div class="col-8">
        {{ $root.displayDateTimeFmt(digest_should_start_at) || 'n/a'}}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Weekday To Send On
      </div>
      <div class="col-8">
        {{ digest_weekday || 'Not Set'}}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Interval
      </div>
      <div class="col-8">
        {{ readable_digest_interval || 'Not Set'}}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Digest Dates
      </div>
      <div class="col-8">
        {{ digest_dates || 'Not Set'}}
      </div>
    </div>
    <div
      class="row mt-3"
    >
      <div
        class="col"
      >
        <preview-email
          :url="this.apiUrl(`/newsletter_types/{{ id }}/preview_email`, true)"
        />
      </div>
    </div>
    <!-- // not implemented / can be viewed via digest working newsletter
    <button
      class="btn btn-block btn-primary"
    >
      Send Preview Email of Upcoming Digest
    </button>
    -->
  </div>
</div>

</template>

<script>
import NewsletterTypeStore from '@/stores/NewsletterTypeStore'

export default {
  data () {
    let state = NewsletterTypeStore.state

    return state
  },

  methods: {
    previewLatestDigest (ev) {
      console.log('PREVIEW LATEST DIGEST')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeDigest.vue